import React from 'react';
import classnames from 'classnames';

interface CheckboxLabelProps {
    label: string;
    sublabel?: string;
    infoButton?: React.ReactNode;
    externalLinkLabel?: React.ReactNode;
}

export const CheckboxLabel = ({ label, sublabel, infoButton, externalLinkLabel }: CheckboxLabelProps): JSX.Element => (
    <>
        <legend
            className={classnames('sgw-checkbox-legend', {
                'sgw-checkbox-legend__with-sublegend': sublabel !== undefined,
            })}
        >
            <span className="sgw-checkbox-legend-text">{label}</span>
            {infoButton && !sublabel && infoButton}
        </legend>
        {sublabel && (
            <p className="sgw-checkbox-sublegend">
                <span className="sgw-checkbox-sublegend-text">{sublabel}</span>
                {infoButton}
            </p>
        )}
        {externalLinkLabel && <div className="sgw-checkbox__external-link-label">{externalLinkLabel}</div>}
    </>
);
